import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/rationalprogression.pdf'; 
import { Helmet } from 'react-helmet';
import QuadratureMobile from '../images/quadrature.png';
import QuadratureMobile2 from '../images/quadrature2.png';

function RationalProgression() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>Sämtliche Schriften und Briefe</var> series VII volume 6<br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp88-91<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 10 September - October 1674<br /><br />
		Translated from the French<br /><br />{isMobile ? '' : <hr className="centered-hr" />}    
		<Link to={pdf} target="_blank">View this translation in PDF format (275k)</Link><br /><br />
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>The Quadrature of the Circle by a Rational Progression</title>
            <meta name="description" content="An English translation of THE QUADRATURE OF THE CIRCLE BY A RATIONAL PROGRESSION by Gottfried Wilhelm Leibniz, from 10 September - October 1674" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <td className="pdf-container">
                    <h2 className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: THE QUADRATURE OF THE CIRCLE BY A RATIONAL PROGRESSION</h2>
                    {isMobile ? renderLinks() : ''}
                    {isMobile ? <><img src={QuadratureMobile} width="100%" /><img src={QuadratureMobile2} width="100%" /></>: <embed src={pdf} className="responsive-embed"/>}
		              </td>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default RationalProgression;